






































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

const checks = [
  [
    'Уникальность: Антиплагиат 50%',
    'Уникальность: Etxt 30%',
    'Уникальность: нет замены русских букв на английские и спец.символы',
    'Объём: соответствует изначально заданному',
    'Титульный лист: не нужен',
    'Структура: присутствует план, введение, заключение, список литературы',
    'План: используется функция автоматического оглавления',
    'План: соответствует изначально заданному',
    'Введение: выделены актуальность, цель, задачи',
    'Введение: объём больше 3/4 страницы',
    'Сноски: присутствуют',
    'Сноски: достаточное суммарное количество (не меньше 1 на 4 стр.)',
    'Сноски: оформлены внизу страницы',
    'Сноски: нет внутритекстовых сносок',
    'Заключение: объём больше 3/4 страницы',
    'Заключение: выводы по работе',
    'Литература: не старше 6-8 лет',
    'Шрифт: 14 таймс, цвет чёрный, интервал полуторный, выравнивание текста по ширине, без переносов',
    'Поля: верхнее, нижнее - 2; левое - 3; правое - 1',
    'Таблицы: шрифт 12, одинарный интервал',
    'Нумерация: нумерация страниц снизу справа'
  ],
  [
    'План: несколько пунктов (2-5), пункты не разделяются на подпункты',
    'Литература: минимум 10 источников'
  ],
  [
    'План: 2-3 главы, которые разбиваются на пункты (2-3)',
    'Литература: минимум 15 источников'
  ],
  [
    'План: 2-3 главы, которые разбиваются на пункты (2-3)',
    'План: первая глава - теоретическая, вторая практическая (описание предприятия, его операций), третья - аналитическая (рекомендации по проблематике применительно к предприятию). Третья глава может не выделяется, а делается как подпункт второй главы',
    'Литература: минимум 15 источников'
  ],
  [
    'Уникальность: Антиплагиат 60%',
    'Уникальность: Etxt 40%',
    'План: 2-3 главы, которые разбиваются на пункты (2-3)',
    'План: первая глава - теоретическая, вторая практическая (описание предприятия, его операций), третья - аналитическая (рекомендации по проблематике применительно к предприятию). Третья глава может не выделяется, а делается как подпункт второй главы',
    'Введение: выделены предмет и объект',
    'Введение: объём больше 1.5 страниц',
    'Литература: минимум 20 источников'
  ]
]

const sections = [
  'Общие',
  'Реферат/контрольная',
  'Теоретическая курсовая',
  'Практическая курсовая',
  'Диплом'
]

@Component({})
export default class Checklist extends Vue {
  public checks = checks
  public sections = sections

  @Prop() checksData!: boolean[]

  idxMap (sectionIdx: number, checkIdx: number): number {
    let res = 0

    for (let i = 0; i < sectionIdx; i++) {
      res += checks[i].length
    }

    res += checkIdx

    return res
  }
}
